import { Suspense } from 'react';
import { useLocation } from 'react-router';
import AllRoutes from '@/components/route/AllRoutes';
import Loading from '@/components/shared/Loading';

const Views = () => {
  const location = useLocation();

  return (
    <Suspense key={location.key} fallback={<Loading loading={true} className="w-full" />}>
      <AllRoutes />
    </Suspense>
  );
};

export default Views;
